/**
 * Enumeration representing possible status values for mandates.
 * @const {Array.<{name: string, value: string}>}
 * @readonly
 */
export const MANDATE_STATUS_ENUM = [
    /**
     * @type {string}
     * Mandate status: Active.
     */
    { name: 'Active', value: 'ACTIVE' },

    /**
     * @type {string}
     * Mandate status: Completed.
     */
    { name: 'Completed', value: 'COMPLETED' },

    /**
     * @type {string}
     * Mandate status: Pause.
     */
    { name: 'Pause', value: 'PAUSE' },

    /**
     * @type {string}
     * Mandate status: Cancelled.
     */
    { name: 'Cancelled', value: 'CANCELLED' },

    /**
     * @type {string}
     * Mandate status: Failed.
     */
    { name: 'Failed', value: 'FAILED' },
];

/**
 * Enumeration representing possible payment modes for mandates.
 * @const {Array.<{name: string, value: string}>}
 * @readonly
 */
export const MANDATE_PAYMENT_MODE = [
    /**
     * @type {string}
     * Payment mode: Credit Card.
     * Currently Not Available;
     */
    // { name: 'Credit Card', value: 'CC' },

    /**
     * @type {string}
     * Payment mode: UPI.
     */
    { name: 'UPI', value: 'UPI' },
];

/**
 * Map representing customer details for mandates.
 * @const {Array.<{label: string, key: string}>}
 * @readonly
 */
export const MANDATE_CUSTOMER_DETAILS_MAP = [
    /**
     * @type {string}
     * Label: Subscription ID.
     * Key: subscriptionID.
     */
    { label: 'Subscription ID', key: 'subscriptionID' },

    /**
     * @type {string}
     * Label: Email ID.
     * Key: emailId.
     */
    { label: 'Email ID', key: 'emailId' },

    /**
     * @type {string}
     * Label: Customer ID.
     * Key: customerID.
     */
    { label: 'Customer ID', key: 'customerID' },

    /**
     * @type {string}
     * Label: Phone No.
     * Key: phoneNo.
     */
    { label: 'Phone No.', key: 'phoneNo' },
];

/**
 * Map representing billing details for mandates.
 * @const {Array.<{label: string, key: string}>}
 * @readonly
 */
export const MANDATE_BILLING_DETAILS_MAP = [
    /**
     * @type {string}
     * Label: Billing Frequency.
     * Key: frequency.
     */
    { label: 'Billing Frequency', key: 'frequency' },

    /**
     * @type {string}
     * Label: Billing Amount.
     * Key: billingAmount.
     */
    { label: 'Billing Amount', key: 'billingAmount' },

    /**
     * @type {string}
     * Label: Payment Method.
     * Key: payType.
     */
    { label: 'Payment Method', key: 'payType' },
];

/**
 * Map representing basic billing details for mandates.
 * @const {Array.<{label: string, key: string}>}
 * @readonly
 */
export const MANDATE_BILLING_DETAILS_BASIC_MAP = [
    /**
     * @type {string}
     * Label: Created At.
     * Key: createdAt.
     */
    { label: 'Created At', key: 'createdAt' },

    /**
     * @type {string}
     * Label: Last Payment.
     * Key: lastPaidAt.
     */
    { label: 'Last Payment', key: 'lastPaidAt' },

    /**
     * @type {string}
     * Label: Next Due On.
     * Key: nextDueOn.
     */
    { label: 'Next Due On', key: 'nextDueOn' },
];

/**
 * Columns configuration for displaying mandates.
 * @const {Array.<{header: string, accessor: string}>}
 * @readonly
 */
export const MANDATE_COLUMNS = [
    /**
     * @type {string}
     * Header: Merchant Name.
     * Accessor: entityCode.
     */
    { header: 'Merchant Name', accessor: 'entityCode' },

    /**
     * @type {string}
     * Header: Payment Instrument.
     * Accessor: Payment Instrument.
     */
    { header: 'Payment Instrument', accessor: 'paymentInfo' },

    /**
     * @type {string}
     * Header: Customer ID.
     * Accessor: customerID.
     */
    { header: 'Customer ID', accessor: 'customerID' },

    /**
     * @type {string}
     * Header: Created At.
     * Accessor: createdAtDate.
     */
    { header: 'Created At', accessor: 'createdAtDate' },

    /**
     * @type {string}
     * Header: Last Payment.
     * Accessor: lastPaidDate.
     */
    { header: 'Last Payment', accessor: 'lastPaidDate' },

    /**
     * @type {string}
     * Header: Next Due On.
     * Accessor: nextDueOnDate.
     */
    { header: 'Next Due On', accessor: 'nextDueOnDate' },

    /**
     * @type {string}
     * Header: Status.
     * Accessor: status.
     */
    { header: 'Status', accessor: 'status' },

    /**
     * @type {string}
     * Header: Action.
     * Accessor: action.
     */
    { header: 'Action', accessor: 'action' },
];
